import * as uiCart from './localState/uiCart';
import toPairs from 'lodash/toPairs';
import merge from 'lodash/merge';

// Add new local Apollo state in this array to activate it.
// The objects in the CLIENT_STATE_CONFIG array can have the following properties:
// - `defaultState`: Object. Required.
//   An object with initial state that will be written to the cache so that querying before
//   mutating doesn't error out.
//   -> https://www.apollographql.com/docs/react/data/local-state/#initializing-the-cache
// - `typeDefs`: String. Optional.
//   Used for introspection in Apollo Client DevTools
//   -> https://www.apollographql.com/docs/react/data/local-state/#client-side-schema
// - `customCacheIdentifiers`: Object. Optional.
//   A map of functions which return the Apollo Cache ids for specific Graphql Types.
//   Used in `dataIdFromObjects`.
//   -> https://www.apollographql.com/docs/react/caching/cache-configuration/#custom-identifiers
// - `resolvers`: Object. Optional.
//   An object with local resolvers for the newly added local state.
//   -> https://www.apollographql.com/docs/react/data/local-state/#local-resolvers
const LOCAL_STATE_CONFIG = { uiCart };

const getLocalState = () =>
  toPairs(LOCAL_STATE_CONFIG).reduce(
    (mergedLocalState, [localStateKey, localState]) => {
      if (!localState.defaultState) {
        // You need to export a `defaultState` object from the local Apollo state module.
        throw new Error(
          `"defaultState" is required for "${localStateKey}" local Apollo state.`
        );
      }

      if (localState.typeDefs) {
        mergedLocalState.typeDefsArray = [
          ...(mergedLocalState.typeDefsArray || []),
          localState.typeDefs,
        ];
      }

      ['defaultState', 'customCacheIdentifiers', 'resolvers'].forEach(
        configKey => {
          if (localState[configKey]) {
            mergedLocalState[configKey] = merge(
              mergedLocalState[configKey] || {},
              localState[configKey]
            );
          }
        }
      );

      return mergedLocalState;
    },
    { defaultState: {} }
  );

export { getLocalState };
